/** Таймаут онлайн-запросов каталога на desktop (не ждём 20с при обрыве сети). */
export const POS_CATALOG_ONLINE_TIMEOUT_MS = 4_000;
